import React, { FunctionComponent } from 'react'

import { useTranslation } from 'react-i18next'

import { Button, ButtonSize, ButtonVariant } from '@/atoms/button'
import { Flex } from '@/atoms/layout'
import { Space } from '@/styles'

interface Props {
  removeFile: () => void
  downloadFile: () => void
}

const ActionButtons: FunctionComponent<Props> = ({ removeFile, downloadFile }) => {
  const { t } = useTranslation()

  return (
    <Flex>
      <Button onClick={downloadFile} mr={Space.S16} variant={ButtonVariant.FLAT} size={ButtonSize.SMALL}>
        {t('global.download_btn')}
      </Button>
      <Button onClick={removeFile} variant={ButtonVariant.FLAT_ERROR} size={ButtonSize.SMALL}>
        {t('global.remove_file_btn')}
      </Button>
    </Flex>
  )
}

export default ActionButtons
